import { useState, useEffect } from "react";
import styles from "./CookiePolicy.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import CustomLink from "@Components/CustomLink";
import useTranslationHook from "hooks/useTranslationHook";

const CookiePolicy = () => {
  const [showCookie, setShowCookie] = useState(false);
  const { t } = useTranslationHook();

  useEffect(() => {
    try {
      if (!window?.localStorage?.hasReadCookie) {
        setShowCookie(true);
      }
    } catch (error) {
      console.error("Error accessing localStorage", error);
    }
  }, []);

  const onClickCross = () => {
    try {
      window.localStorage.hasReadCookie = true;
    } catch (error) {
      console.error("Error setting localStorage", error);
    }
    setShowCookie(false);
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLSpanElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      onClickCross();
    }
  };

  return showCookie ? (
    <div className={styles.cookieIndexContainer}>
      <div className={styles.innerContainer}>
        {t("cookie.policy.text")} {t("cookie.policy.seeour")}{" "}
        <CustomLink href="/privacy" target="_blank" rel="noreferrer" className={styles.privacyLink}>
          {" "}
          {t("cookie.policy.link")}
        </CustomLink>{" "}
        <span
          aria-label="Close Cookie Policy"
          className={styles.crossBtn}
          onClick={onClickCross}
          role="button"
          tabIndex={0}
          onKeyPress={handleKeyPress}
        />
      </div>
    </div>
  ) : null;
};

export default wrapperHOC(CookiePolicy, {
  componentName: "CookiePolicy-Global",
  showForChina: true,
});
